export const localeRoot = "settings.paywalls.modal.tabs.checkout";

export const PROPERTIES = {
  DEFAULT: "default",
  TESTIMONIALS: "testimonials",
};
